export const gisSolutions = [
  {
    name: 'Cartography & Map Production',
    desc: 'Professional mapping and spatial visualization',
    details: [
      {
        title: 'Thematic maps',
        desc: 'Custom maps for planning, environment, and reporting',
      },
      {
        title: 'Base maps & atlases',
        desc: 'Reference and topographic map production',
      },
      {
        title: 'Data visualization',
        desc: 'Choropleth, heat maps, and spatial dashboards',
      },
    ],
  },
  {
    name: 'Spatial Data Management',
    desc: 'Data capture, storage, and integration',
    details: [
      {
        title: 'Data modeling',
        desc: 'Geodatabases and schema design',
      },
      {
        title: 'Data conversion',
        desc: 'ETL and format migration (CAD, shapefile, GeoJSON, etc.)',
      },
      {
        title: 'Quality & standards',
        desc: 'Validation, metadata, and INSPIRE compliance',
      },
    ],
  },
  {
    name: 'Web GIS & Applications',
    desc: 'Online mapping and GIS in the browser',
    details: [
      {
        title: 'Web map applications',
        desc: 'Interactive maps and viewer portals',
      },
      {
        title: 'Mobile & field apps',
        desc: 'Data collection and offline-capable solutions',
      },
      {
        title: 'APIs & integration',
        desc: 'REST APIs and integration with existing systems',
      },
    ],
  },
  {
    name: 'Spatial Analysis & Modeling',
    desc: 'Analysis and decision support',
    details: [
      {
        title: 'Site selection & suitability',
        desc: 'Multi-criteria analysis and modeling',
      },
      {
        title: 'Network & routing',
        desc: 'Transport, utilities, and logistics analysis',
      },
      {
        title: 'Terrain & 3D',
        desc: 'DEM analysis, viewshed, and 3D visualization',
      },
    ],
  },
]
